/** Project → Finance: client purchase orders assigned to this job (income side). */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardList, ExternalLink } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const gbp = (n) => (n == null ? '—' : `£${Number(n).toLocaleString('en-GB', { minimumFractionDigits: 2 })}`);
const fmtD = (s) => (s ? new Date(s).toLocaleDateString('en-GB') : '—');

export function ProjectClientPoCard({ projectId }) {
  const { api, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!isAdmin || !projectId) return undefined;
    let cancelled = false;
    api.get(`/client-pos/project/${projectId}`).then(r => { if (!cancelled) setData(r.data); }).catch(() => {});
    return () => { cancelled = true; };
  }, [api, projectId, isAdmin]);
  if (!isAdmin || !data?.count) return null;
  return (
    <Card className="bg-[#2A3240] border-white/10 mb-6" data-testid="project-client-po-card">
      <CardHeader className="pb-2 flex flex-row items-center justify-between">
        <CardTitle className="text-lg text-white flex items-center gap-2"><ClipboardList className="w-5 h-5 text-[#F5A623]" /> Client PO income</CardTitle>
        <div className="text-right">
          <div className="text-xl font-bold text-emerald-300 tabular-nums" data-testid="project-client-po-total">{gbp(data.total_pounds)}</div>
          <div className="text-[10px] text-gray-500">ex VAT · {data.count} PO{data.count === 1 ? '' : 's'}</div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="divide-y divide-white/5">
          {data.items.map(po => (
            <div key={po.id} className="py-2 flex items-center gap-3 text-sm" data-testid={`project-client-po-${po.id}`}>
              <div className="flex-1 min-w-0">
                <div className="text-white font-medium truncate">{po.po_number || 'PO'} <span className="text-gray-400 font-normal">· {po.client_name || ''}</span></div>
                <div className="text-xs text-gray-500">{fmtD(po.po_date)}{po.description ? ` · ${po.description}` : ''}{po.status === 'closed' ? ' · closed' : ''}</div>
              </div>
              <div className="text-white font-semibold tabular-nums">{gbp(po.value_pounds)}</div>
              <button type="button" onClick={() => navigate(`/client-pos?open=${po.id}`)} className="text-[#F5A623] hover:underline text-xs inline-flex items-center gap-1" data-testid={`project-client-po-open-${po.id}`}>open <ExternalLink className="w-3 h-3" /></button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
